export const CREATE_REGISTRY_FROM_WEDDINGS = 'zola/registry/CREATE_REGISTRY_FROM_WEDDINGS';
export const REGISTRY_PUBLISHED = 'zola/registry/REGISTRY_PUBLISHED';
export const RECEIVE_REGISTRY = 'zola/registry/RECEIVE_REGISTRY';
export const REQUEST_REGISTRY = 'zola/registry/REQUEST_REGISTRY';
export const HAS_SHIPPING_ADDRESS = 'zola/registry/HAS_SHIPPING_ADDRESS';
export const REGISTRY_ERROR = 'zola/registry/REGISTRY_ERROR';



// WEBPACK FOOTER //
// ./src/actions/types/RegistryActionTypes.js